import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGoldMedal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gold-medal, first-place, win"><circle cx="12" cy="10" r="7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 16.5V22.25L12 21.2L16.25 22.25V16.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12.8789 6V14H11.1875V7.60547H11.1406L9.30859 8.75391V7.25391L11.2891 6H12.8789Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGoldMedal;
